import { Onboarding } from '@components/Onboarding'

export default function OnboardingScreen() {
  return <Onboarding />
}
